import React, { useState, useEffect, useRef, useContext } from "react";
import { MenuProps, Spin, TablePaginationConfig } from "antdv5";
import { v4 as uuidv4 } from "uuid";
import DefaultLayout from "components/layout/DefaultLayout";
import useAPI from "components/customHook/useApi";
import { DailyDetail } from "../styles/ScanDetail";
import FunctionBox from "components/pages/ScanDetail/FunctionBox";
import Result from "components/pages/ScanDetail/Result";
import ScanDetailTable from "components/pages/ScanDetail/ScanDetailTable";
import { Obj } from "../client_types";
import {
  GETJsonDailyExportDataAction,
  GETJsonDeviceActionIDList,
  GETJsonMessageDailyActionID,
} from "../api";
import { context } from "components/context/Context";
import { notification } from "antdv5";
import XLSX from "xlsx";

const keys = ["HH", "MM", "SS"];
const FFkey = ["FF"];
const longtitude = ["Avela", "Avefen", "Avesec"];
const latitude = ["Avnla", "Avnfen", "Avnsec"];

const obsKeyToString = (o: Obj, a: string[], s = ",") =>
  a
    .filter((c) => o[c])
    .map((c) => o[c])
    .join(s);

const giveStringData = (item: Obj) => ({
  stringDate: `${obsKeyToString(item, keys, ":")}.${obsKeyToString(
    item,
    FFkey,
    "."
  )}`,
  east: obsKeyToString(item, longtitude, "'"),
  north: obsKeyToString(item, latitude, "'"),
});

const DailyRecord = () => {
  const {
    handleAuth,
    preventRefreshCount,
    loading: spinLoading,
    handleEnter,
    clubList,
  } = useAPI();
  const [api, ctx] = notification.useNotification();
  const { state } = useContext(context);
  const [data, setData] = useState<{
    data: any;
    count: string | number;
  }>({ data: [], count: "" });
  const [rank, setRank] = useState("ASC");
  const [sortText, setSortText] = useState("正序");
  const [findName, setFindName] = useState({
    searchFeetNo: "",
    searchName: "",
    searchNumber: "",
  });
  const [pageInfo, setPageInfo] = useState<{
    pageSize: string | number;
    current: string | number;
  }>({
    pageSize: "",
    current: "",
  });
  const [loading, setLoading] = useState(false);
  const [isChecked, setIsChecked] = useState(true);
  const [searchValue, setSearchValue] = useState("");
  const [actionIDList, setActionIDList] = useState<{ value: string }[]>([]);
  const [storageIsCheck, setStorageIsCheck] = useState<boolean | null>(null);
  const [storageSearchValue, setStorageSearchValue] = useState<{
    feetNo: string;
    matchNumber: string;
    searchName?: string;
    searchNumber?: string;
  }>({
    feetNo: "",
    matchNumber: "",
    searchName: "",
  });
  const [storageSearchActionID, setStorageSearchActionID] = useState("");
  const [lock, setLock] = useState(true);
  const [lockInput, setLockInput] = useState(false);
  const [dateInput, setDateInput] = useState<string | null>(null);
  const [newestActionID, setNewestActionID] = useState("");
  const [autoInput, setAutoInput] = useState({
    value: "",
    searchValue: "",
    dateInput: "",
  });
  const [downloading, setDownloading] = useState(false);
  const handleMenuClick: MenuProps["onClick"] = (e) => {
    if (parseInt(e.key) === 1) {
      setRank("ASC");
      setSortText("正序");
    } else if (parseInt(e.key) === 2) {
      setRank("DES");
      setSortText("倒序");
    }
  };
  const columns = [
    {
      title: "序号",
      dataIndex: "rank",
      width: 100,
    },
    {
      title: "参赛编号",
      dataIndex: "House",
      width: 100,
      textWrap: "word-break",
      ellipsis: true,
      render: (text: string) => (
        <div
          style={{ color: "#3d6bff", cursor: "pointer" }}
          onClick={() => {
            setStorageSearchValue({
              ...storageSearchValue,
              matchNumber: text.trim(),
            });
            setPageInfo({ pageSize: 100, current: 1 });
            preventRefreshCount(searchNewData, 3);
            handleAuth();
          }}
        >
          {text}
        </div>
      ),
    },
    {
      title: "参赛名称",
      dataIndex: "Name",
      width: 180,
      render: (text: string) => (
        <div
          style={{ color: "#3d6bff", cursor: "pointer" }}
          onClick={() => {
            setStorageSearchValue({ ...storageSearchValue, searchName: text });
            setPageInfo({ pageSize: 100, current: 1 });
            preventRefreshCount(searchNewData, 3);
            handleAuth();
          }}
        >
          {text}
        </div>
      ),
    },
    {
      title: "环号",
      dataIndex: "Ring",
      width: 150,
    },
    {
      title: "日期",
      dataIndex: "Ymd",
      width: 150,
    },
    {
      title: "归巢时间",
      dataIndex: "stringDate",
      width: 150,
    },
    {
      title: "备注",
      dataIndex: "note",
      width: 100,
    },
  ];

  const fetchActionID = async () => {
    const json = await GETJsonDeviceActionIDList(
      localStorage.getItem("gid") || "",
      localStorage.getItem("token") || ""
    );
    if (json.Data?.length && json.Data.length > 0) {
      let result: { value: string }[] = [];
      const extractTime = (item: string) => {
        const result = item.split(" ");
        return result[0];
      };
      json.Data.slice(0, 10).forEach(
        (item: { Date: string; ActionID: string }) => {
          result.push({
            value:
              extractTime(item.Date.replace(/T/g, " ")) + " " + item.ActionID,
          });
        }
      );
      setActionIDList(result);
      setNewestActionID(json.Data[0].ActionID);
      setDateInput(json.Data[0].Date.split("T")[0]);
      localStorage.setItem("newest", json.Data[0].Date.split("T")[0]);
      setStorageSearchActionID(json.Data[0].ActionID);
    } else {
      let result = [{ value: "查无资料" }];
      setActionIDList(result);
      setNewestActionID("");
    }
  };
  const fetchData = () => {
    setLoading(true);
    setLock(true);
    setLockInput(true);
    setStorageSearchValue({
      feetNo: findName.searchFeetNo,
      matchNumber: findName.searchNumber,
      searchName: findName.searchName,
    });
    setStorageIsCheck(isChecked);
    setData({ data: "", count: "" });

    const token = localStorage.getItem("token") || "";
    const gid = localStorage.getItem("gid") || "";
    const searchName = encodeURIComponent(findName.searchName);
    const actionID = encodeURIComponent(
      searchValue !== "" ? searchValue : newestActionID
    );
    GETJsonMessageDailyActionID(
      gid,
      actionID,
      rank,
      pageInfo.pageSize,
      pageInfo.current,
      findName.searchFeetNo,
      findName.searchNumber,
      searchName,
      isChecked,
      token
    ).then((res) => {
      let data =
        res.Data?.map((elem: Obj, i: number) => ({
          ...elem,
          ...giveStringData(elem),
          id: uuidv4(),
          rank: rank === "ASC" ? i + 1 : res.Data[0].Count - i,
        })) || [];
      if (data.length > 0) {
        setData({ data, count: res.Data[0].Count });
      } else {
        api.info({
          message: "注意!",
          description: "伺服器查无资料",
          placement: "top",
        });
        setData({ data: [], count: "" });
      }
      setLoading(false);
      setLock(false);
      setLockInput(false);
    });
  };
  const fetchNewData = (pageSize = 100, current = 1) => {
    setLoading(true);
    if (pageInfo.current === "") {
      setPageInfo({ pageSize: 100, current: 1 });
    }
    if (storageSearchActionID !== "") {
      const gid = localStorage.getItem("gid") || "";
      const token = localStorage.getItem("token") || "";
      GETJsonMessageDailyActionID(
        gid,
        encodeURIComponent(storageSearchActionID),
        rank,
        pageSize,
        current,
        storageSearchValue.feetNo,
        storageSearchValue.matchNumber,
        encodeURIComponent(storageSearchValue.searchName || ""),
        storageIsCheck || false,
        token
      ).then((res) => {
        let data = res?.Data?.map((elem: Obj, i: number) => {
          let item = {
            ...elem,
            ...giveStringData(elem),
            id: uuidv4(),
            rank: 0,
          };
          if (rank === "ASC") {
            item.rank = (current - 1) * pageSize + 1 + i;
          } else {
            item.rank = res.Data[0].Count - (current - 1) * pageSize - i;
          }
          return item;
        });
        if (data.length > 0) {
          setData({
            data,
            count: res.Data[0].Count,
          });
        } else {
          setData({ data: [], count: "" });
        }
        setLoading(false);
        setLock(false);
        setLockInput(false);
      });
    } else {
      setLoading(false);
      // setLock(false)
      setLockInput(false);
    }
  };
  const onTableChange = (pagination: TablePaginationConfig) => {
    handleAuth();
    setPageInfo({
      pageSize: pagination.pageSize || 100,
      current: pagination.current || 1,
    });
    fetchNewData(pagination.pageSize, pagination.current);
  };
  const handleCurrentPage = () => {
    let result = null;
    if (pageInfo.current === "") {
      result = 1;
    } else {
      result = pageInfo.current as number;
    }
    return result;
  };
  const handleDownload = async () => {
    let confirm = window.confirm(
      `请确认汇出档案的训练建立日期: ${dateInput}   排除重复：${
        storageIsCheck ? "是" : "否"
      }   参赛编号: ${storageSearchValue.matchNumber || "无"}   参赛名称：${
        storageSearchValue.searchName || "无"
      }   足环号：${storageSearchValue.feetNo || "无"}`
    );

    if (confirm) {
      setDownloading(true);
      const gid = localStorage.getItem("gid") || "";
      const token = localStorage.getItem("token") || "";
      const actionID = encodeURIComponent(
        searchValue !== "" ? searchValue : newestActionID
      );
      const searchName = encodeURI(storageSearchValue.searchName || "");
      let printData = await GETJsonDailyExportDataAction(
        gid,
        actionID,
        rank,
        storageSearchValue.feetNo,
        storageSearchValue.matchNumber,
        searchName,
        storageIsCheck || false,
        token
      ).then((json) =>
        json.Data.map((elem: Obj, i: number) => ({
          ...elem,
          ...giveStringData(elem),
          id: uuidv4(),
          rank: rank === "ASC" ? i + 1 : json.Data[1].Count - i,
        })).map((item: Obj) => ({
          序号: item.rank.toString(),
          参赛编号: item.House,
          参赛名称: item.Name,
          环号: item.Ring,
          日期: item.Ymd,
          归巢时间: item.stringDate,
          备注: item.note,
        }))
      );
      dataToXlsx(printData);
      if (printData.length > 0) {
        setDownloading(false);
      }
    }
  };
  function useDebounce<T>(fn: T, delay: number) {
    const ref = useRef<{ fn: T; timer: any }>({ fn, timer: null });
    useEffect(() => {
      ref.current.fn = fn;
    }, [fn]);
    function f(...args: any[]) {
      if (ref.current.timer) {
        clearTimeout(ref.current.timer);
      }
      ref.current.timer = setTimeout(function (this: any) {
        (ref.current.fn as Function).call(this, ...args);
      }, delay);
    }
    return f;
  }
  const searchData = useDebounce(fetchData, 100);
  const searchNewData = useDebounce(fetchNewData, 100);
  const fakePreventRefresh = (): false => {
    return false;
  };
  const dataToXlsx = async (tableData: Obj[]) => {
    if (tableData) {
      const sheet = XLSX.utils.json_to_sheet(tableData);
      const workbook = XLSX.utils.book_new();
      sheet["!cols"] = [
        { wch: 10 },
        { wch: 12 },
        { wch: 30 },
        { wch: 20 },
        { wch: 10 },
        { wch: 12 },
      ];
      XLSX.utils.book_append_sheet(workbook, sheet, "workbook");
      XLSX.writeFile(workbook, "资料表.xlsx");
    } else {
      return;
    }
  };
  const handleSearch = () => {
    setPageInfo({ pageSize: "", current: "" });
    preventRefreshCount(searchData, 3);
  };
  useEffect(() => {
    handleAuth();
  }, []);
  useEffect(() => {
    handleAuth();
    preventRefreshCount(fakePreventRefresh, 3);
  }, [localStorage.getItem("gid"), rank]);
  useEffect(() => {
    setFindName({ searchFeetNo: "", searchName: "", searchNumber: "" });
    setData({ data: [], count: "" });
    setStorageSearchValue({
      feetNo: "",
      matchNumber: "",
      searchNumber: "",
    });
    setAutoInput({
      value: "",
      searchValue: "",
      dateInput: "",
    });
    setSearchValue("");
    setStorageIsCheck(null);
    // need to use await to avoid race condition,
    // fetchActionID() sets newestActionID, which
    // searchData() needs if user hasn't selected an actionID
    (async () => {
      await fetchActionID();
      searchData();
    })();
  }, [state?.gid]);
  useEffect(() => {
    fetchNewData(pageInfo.pageSize as number, pageInfo.current as number);
  }, [rank]);
  useEffect(() => {
    if (actionIDList.length > 0) {
      if (actionIDList[0].value.split(" ")[1] === newestActionID) {
        return;
      } else {
        searchData();
      }
    }
  }, [actionIDList, state?.gid]);
  return (
    <>
      {ctx}
      <DefaultLayout>
        <Spin spinning={spinLoading} tip={"请等候3秒"}>
          <Spin spinning={downloading} tip={"下载中"}>
            <DailyDetail>
              <FunctionBox
                clubList={clubList}
                findName={findName}
                setFindName={setFindName}
                handleEnter={handleEnter}
                handleSearch={handleSearch}
                autoInput={autoInput}
                actionIDList={actionIDList}
                setAutoInput={setAutoInput}
                setLock={setLock}
                dateInput={dateInput || ""}
                lockInput={lockInput}
                setIsChecked={setIsChecked}
                preventRefreshCount={preventRefreshCount}
                searchData={searchData}
                isChecked={isChecked}
                handleAuth={handleAuth}
                setPageInfo={setPageInfo}
                pageInfo={pageInfo}
                setDateInput={setDateInput}
                setStorageSearchActionID={setStorageSearchActionID}
                setSearchValue={setSearchValue}
                newestActionID={newestActionID}
                setStorageIsCheck={setStorageIsCheck}
                setStorageSearchValue={setStorageSearchValue}
              />
              <Result
                dateInput={dateInput}
                storageIsCheck={storageIsCheck}
                storageSearchValue={storageSearchValue}
              />
              <ScanDetailTable
                className="bordered-table"
                columns={columns}
                data={data}
                sortText={sortText}
                handleDownload={handleDownload}
                fetchNewData={fetchNewData}
                preventRefreshCount={preventRefreshCount}
                setLockInput={setLockInput}
                setLock={setLock}
                handleCurrentPage={handleCurrentPage}
                onTableChange={onTableChange}
                loading={loading}
                pageInfo={pageInfo}
                fakePreventRefresh={fakePreventRefresh}
                handleMenuClick={handleMenuClick}
              />
            </DailyDetail>
          </Spin>
        </Spin>
      </DefaultLayout>
    </>
  );
};

export default DailyRecord;
